import { type FC, type PropsWithChildren } from 'react';

import { apiConfigurationContext } from '../contexts';
import { useGetApiConfigurationData } from '../hooks';

export type ApiConfigurationProviderProps = PropsWithChildren<{
  tenant: string;
}>;

export const ApiConfigurationProvider: FC<ApiConfigurationProviderProps> = ({ tenant, children }) => {
  const contextValue = useGetApiConfigurationData({ tenant });

  return <apiConfigurationContext.Provider value={contextValue}>{children}</apiConfigurationContext.Provider>;
};
